const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const getWeeklySetup = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_WEEKLY_ALLOCATION':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_WEEKLY_ALLOCATION_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'RESET_SERVICE_WEEKLY_ALLOCATION':
    return {...INITIAL_STATE} 
  default:
    return { ...state }
  }
};
    
export default getWeeklySetup;